export enum PrinterType {
  PdfCreator = 0,
  LinePrinter1 = 101,
  LinePrinter2 = 102,
  LinePrinterSelectionLabelling1 = 1,
  LinePrinterSelectionLabelling2 = 2,
  LinePrinterSelectionReturn = 3,
  LinePrinterSelectionBackup = 4,
  DepartmentPrinter1 = 7,
  DepartmentPrinter2 = 8,
  AutoLabellerPrinter = 9,
  Unspecified = 99,
}
